import { toBlob } from 'html-to-image';

import { saveGeneratedFile } from '@/utils/file-io';
import { handleExternalUrlClick } from '@/utils/platform';

const SHARE_IMAGE_OPTIONS = {
  pixelRatio: 2,
  cacheBust: true,
  backgroundColor: '#050814',
};

export const downloadShareImage = async (
  node: HTMLElement,
  filename: string
) => {
  await saveGeneratedFile(filename, async () => {
    const blob = await toBlob(node, SHARE_IMAGE_OPTIONS);
    if (!blob) throw new Error('Failed to render the share image');
    return blob;
  });
};

export const copyShareImage = async (node: HTMLElement): Promise<boolean> => {
  try {
    const blob = await toBlob(node, SHARE_IMAGE_OPTIONS);
    if (!blob) return false;
    await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
    return true;
  } catch {
    return false;
  }
};

export const buildShareUrl = (shareId: string) =>
  `${window.location.origin}/wrapped/${shareId}`;

export const openTweetIntent = (
  periodLabel: string,
  topTool: string,
  daysActive: number,
  shareUrl: string
) => {
  const text = `My ${periodLabel} AI Report: ${topTool} was my daily driver across ${daysActive} days, tracked by @LittlebirdAI. See yours:`;
  const params = new URLSearchParams({ text, url: shareUrl });
  handleExternalUrlClick(`https://x.com/intent/tweet?${params.toString()}`);
};

export const shareFilename = (periodLabel: string) =>
  `littlebird-wrapped-${periodLabel.toLowerCase().replace(/\s+/g, '-')}.png`;
